'use strict';

import angular from 'angular';

export default angular.module('syncplicityLoginApp.auth.interceptor', [])
  .service('authInterceptor', ["$window", "$q", "$location", ($window, $q, $location) => {
        return {
            response: response => {
                if(response.status === 401 && response.config.url.indexOf('/api/') >= 0) {
                    console.log("Response 401");
                    $window.location = '/api/oauth/authorize';
                    return;
                }
                return response || $q.when(response);
            },
            responseError: rejection => {
                if(rejection.status === 401 && rejection.config.url.indexOf('/api/') >= 0) {
                    console.log("Response Error 401", rejection);
                    $window.location = '/api/oauth/authorize';
                    return;
                }
                return $q.reject(rejection);
            }
        };      
  }]).name;



// WEBPACK FOOTER //
// ./client/components/util/auth.interceptor.js